export default "__VITE_ASSET__2a377b31__"